import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EpahafService } from '../epahaf.service';




@Component({
    selector: 'app-pahaf-chart',
    templateUrl: './pahaf-chart.component.html',
    styleUrls: ['./pahaf-chart.component.scss'],
    standalone: false
})
export class PahafChartComponent implements OnInit {
  @Input() public uname;
  @Output() close: EventEmitter<void> = new EventEmitter();
  pcpmemberdetails: any = [];
  uniquePCP: any =[];
  dropdownPCPList: any = [];
  tempdp: any;
  pcpstatusCount: any = [];
  InprogressCount: any;
  notReceivedCount: any;
  paidCount: any;
  approvedCount: any;
  declinedCount: any;
  onHoldMissingClaimCount: any;
  onHoldNonAWVClaimCount: any;
  partiallyCompletedCount: any;
  paperInProgressCount:any
  providerfeedbackCount: any;
  totalStatusCount: any;
  datacount: any [];
  view: any[] = [850, 400];
  showLegend: boolean = false;
  legendPosition: string = "below";
  showLabels: boolean = true;
  trimlabel:  boolean = false;



  constructor(private httpService: HttpClient,
    private pahafService: EpahafService) { }

  ngOnInit() {   
    this.getPCPDetails();

    }

    options = {
      responsive: true,
      legend: {
          position: 'bottom',
          labels: {
              fontColor: "black",
              boxWidth: 10,
              padding: 20,
              usePointStyle: "true"
          }
        },
      tooltips: {
        enabled: true
        },
      plugins: {
    datalabels: 
    {
             }
      }
    }
  
    pieChartLabels =  ['Paid', 'Declined', 'Pending Coder Review','Approved', 'Not Received','onHold','Partially Completed','onHold NonAWV'];
  
    // CHART COLOR.
    pieChartColor:any = [
        {
            backgroundColor: [
              'rgb(0,128,0)',
              'rgb(255,0,0)',
              'rgb(35, 73, 158)',              
              'rgb(102,255,102)',
              'rgb(128,128,128)',
              'rgb(255,0,0)',
              'rgb(128,128,128)',
              'rgb(255,194,0)',

            ]
        }
    ]

    colorScheme = {
      domain: ['rgb(0,128,0)', 'rgb(255,0,0)','rgb(35, 73, 158)','rgb(102,255,102)','rgb(128,128,128)','url(#patternUndecidedRed)','url(#patternUndecidedGrey)','url(#patternUndecided)'],      
    };

    

    pieChartData:any = [
        // {           
        //     data : []                        
        // }
    ];

    onChartClick(event) {
      //console.log(event);
  }

  getPCPDetails() {    
    this.pcpmemberdetails = [];
    this.pahafService.epahafMemberData.subscribe((Response: any) => {      
      //console.log("chart Response :",Response)
     if(Response.length > 0) {            
       this.pcpmemberdetails = Response;
       //console.log("this.pcpmemberdetails :",this.pcpmemberdetails)
  
       if (this.pcpmemberdetails && this.pcpmemberdetails.length) {
       this.pcpmemberdetails.filter((element) => {              
         if(element.pcpId ) {                  
           this.uniquePCP.push({
             id: element.pcpId,
             itemName: element.pcpName
           })
         }
       })
       this.dropdownPCPList = [...new Map(this.uniquePCP.map(item =>[item['itemName'], item])).values()]
       //console.log("uniquePCP -- 2 dropdownPCPList :",this.dropdownPCPList);
       
      }
     }  
   });      
  }

  selectedPCP(event: any) {
    this.pcpstatusCount = [];
    this.InprogressCount = '';
    this.notReceivedCount = '';
    this.paidCount = '';
    this.approvedCount = '';
    this.declinedCount = '';
    this.providerfeedbackCount = '';
    this.onHoldMissingClaimCount = '';
    this.partiallyCompletedCount = '';
    this.onHoldNonAWVClaimCount = '';

    // console.log("event :",event);
    // console.log("Selected PCP value :",event.target.value);
  
    this.pcpmemberdetails.filter((ele) => {              
      if(ele.pcpId == event.target.value) {                  
        this.pcpstatusCount.push({
          id: ele.pcpId,
          itemName: ele.pcpName,
          status: ele.status
        })
      }
    })
    //console.log("pcpstatusCount name :",this.pcpstatusCount[0].itemName)

    this.tempdp = this.pcpstatusCount[0].itemName;
    this.InprogressCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'Pending Coder Review' ? ++acc : acc, 0);
    this.notReceivedCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'Not Received' ? ++acc : acc, 0);
    this.paidCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'Paid' ? ++acc : acc, 0);
    this.approvedCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'Payment Approved' ? ++acc : acc, 0);
    this.declinedCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'Denied' ? ++acc : acc, 0);
    //this.providerfeedbackCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'Provider feedback' ? ++acc : acc, 0);
    this.onHoldMissingClaimCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'On Hold - Missing claim' ? ++acc : acc, 0);
    this.onHoldNonAWVClaimCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'On Hold - Non-AWV Claim' ? ++acc : acc, 0);
    //this.paperInProgressCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'Paper PAHAF In Progress' ? ++acc : acc, 0);    
    this.partiallyCompletedCount = this.pcpstatusCount.reduce((acc, cur) => cur.status === 'Portal In Progress' ? ++acc : acc, 0);
    this.totalStatusCount = this.InprogressCount + this.notReceivedCount + this.paidCount + this.approvedCount + this.declinedCount + this.onHoldMissingClaimCount + this.partiallyCompletedCount + this.onHoldNonAWVClaimCount;

     let paidpercent = (this.paidCount*100 / this.totalStatusCount).toFixed(1)+"%";
     let declinedpercent = (this.declinedCount*100 / this.totalStatusCount).toFixed(1)+"%";
     let inprogresspercent = (this.InprogressCount*100 / this.totalStatusCount).toFixed(1)+"%";
     //let pfpercent = (this.providerfeedbackCount*100 / this.totalStatusCount).toFixed(1)+"%";
     let approvedpercent = (this.approvedCount*100 / this.totalStatusCount).toFixed(1)+"%";
     let nrpercent = (this.notReceivedCount*100 / this.totalStatusCount).toFixed(1)+"%";
     let onHoldpercent = (this.onHoldMissingClaimCount*100 / this.totalStatusCount).toFixed(1)+"%";
     let onHoldNonAWVpercent = (this.onHoldNonAWVClaimCount*100 / this.totalStatusCount).toFixed(1)+"%";
     let partiallyCompletedpercent = (this.partiallyCompletedCount*100 / this.totalStatusCount).toFixed(1)+"%";
     //let paperInProgresspercent = (this.paperInProgressCount*100 / this.totalStatusCount).toFixed(1)+"%";

     this.pieChartData = [
      {name: 'Paid ( ' + paidpercent +' )', value:this.paidCount},
      {name: 'Denied ( ' + declinedpercent+' )', value:this.declinedCount},
      {name: 'Pending Coder Review ( ' + inprogresspercent+' )', value:this.InprogressCount},
      //{name: 'Provider Feedback ( ' + pfpercent+' )', value:this.providerfeedbackCount},
      {name: 'Payment Approved ( ' + approvedpercent+' )', value:this.approvedCount},
      {name: 'Not Received ( ' + nrpercent+' )', value:this.notReceivedCount},
      {name: 'On Hold - Missing claim ( ' + onHoldpercent+' )', value:this.onHoldMissingClaimCount},
      {name: 'Portal In Progress ( ' + partiallyCompletedpercent+' )', value:this.partiallyCompletedCount},
      //{name: 'Paper PAHAF In Progress ( ' + paperInProgresspercent+' )', value:this.paperInProgressCount}
       {name: 'On Hold - Non-AWV Claim ( ' + onHoldNonAWVpercent+' )', value:this.onHoldNonAWVClaimCount},
    ]
  }


  deletedata() {
     //console.log(" new dropdownPCPList -- :",this.dropdownPCPList)
     let selectdp = window.document.getElementById("chartdropdownid") as HTMLSelectElement | null;
     selectdp.selectedIndex = 0; 
    this.InprogressCount = '';
    this.notReceivedCount = '';
    this.paidCount = '';
    this.approvedCount = '';
    this.declinedCount = '';
    this.providerfeedbackCount = '';
    this.onHoldMissingClaimCount = '';
    this.partiallyCompletedCount = '';
    this.onHoldNonAWVClaimCount = '';
    this.tempdp = '';
    this.totalStatusCount = '';
    this.pieChartData = [];        
    window.document.getElementById("close_model_chart").click() ;   
  }

 

}

